import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from '../../../components/Octopath/layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};

const MDXLayout = ({
  children
}) => <Layout>{children}</Layout>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <blockquote>
      <p parentName="blockquote">{`Route has 0L 1-3M extra for random battles. Can use 2Ms for Path to Murkwood fight. If you needed to burn an extra L and got no dupes you'll need to pick up a backup L (Rippletide).`}</p>
    </blockquote>
    <SEO title="Octopath Traveler Ophilia 3 Character" mdxType="SEO" />
    <h3 {...{
      "id": "chapter-1"
    }}>{`Chapter 1`}</h3>
    <p>{`Guide Summon Winds`}<br parentName="p"></br>{`
`}{`Purchase Quartz Rod`}</p>
    <h4 {...{
      "id": "guardian-1924hp"
    }}>{`Guardian 1924HP`}</h4>
    <p>{`Summon, Holy Light x4 when Broken`}</p>
    <p>{`Head to `}<strong parentName="p">{`Atlasdam`}</strong>{`.`}</p>
    <h3 {...{
      "id": "cyrus-ch1"
    }}>{`Cyrus Ch.1`}</h3>
    <p>{`Scrutinize `}<strong parentName="p">{`Light S`}</strong>{`, `}<strong parentName="p">{`Light M`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`Quartz Rod: Cyrus`}</li>
        <li parentName="ul">{`2 Pointed Hat: Cyrus & Ophilia`}</li>
      </ul>
    </Menu>
    <p>{`Pick `}<strong parentName="p">{`Light S`}</strong>{` in Study if no `}<strong parentName="p">{`Shadow S`}</strong>{` drop from Guardian.`}</p>
    <h4 {...{
      "id": "russell-3097hphp"
    }}>{`Russell 3097HP/?HP`}</h4>
    <h5 {...{
      "id": "turn-1"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Summon`}</li>
      <li parentName="ul">{`Cyrus: Fireball`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Staff / Heal / Soulstone if adds broken`}</li>
      <li parentName="ul">{`Cyrus: Fireball`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Same as T2, Holy Light x4 if Russel broken`}</li>
      <li parentName="ul">{`Cyrus: Icewind x4`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4--on"
    }}>{`Turn 4 & on.`}</h5>
    <p>{`Break Russell, hit with big spells and stuff.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "job"
      }}>{`Job`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: Luminiscence`}</li>
        <li parentName="ul">{`Cyrus: Lightning Blast`}</li>
      </ul>
    </Menu>
    <p>{`Head towards Whistlewood. Can kill battles on the way.`}</p>
    <ul>
      <li parentName="ul">{`2/3 Frogs: Luminiscence x2 + Icewind x2`}</li>
      <li parentName="ul">{`1 Frog II 1 Frog I: Luminiscence/Icewind x2 + Light/Ice S, or both boosted spells & kill with attack next turn.`}</li>
      <li parentName="ul">{`3 Ants: LB x2`}</li>
      <li parentName="ul">{`Ants + Meep:`}<ul parentName="li">
          <li parentName="ul">{`If Ophi first: Staff x2 Meep, LB x2`}</li>
          <li parentName="ul">{`If Cyrus first & Ophi before Meep: LB x2, Holy Light x2 (range) or S Stone`}</li>
          <li parentName="ul">{`If Cyrus first * Ophi after Meep: LB, 2x Staff Meep, next turn Fireball x3. Or same as above.`}</li>
        </ul></li>
    </ul>
    <p>{`Pick `}<strong parentName="p">{`$1500`}</strong>{`, kill battle in Whistlewood with Light M. If Howlers break with Lightning Blast first.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "job-1"
      }}>{`Job`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: Blizzard`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: Evasive Maneuvers`}</li>
      </ul>
    </Menu>
    <p>{`Tag `}<strong parentName="p">{`Noblecourt`}</strong>{`. Go to `}<strong parentName="p">{`Forest of Purgation`}</strong>{`. Pick `}<strong parentName="p">{`Light M`}</strong>{`, `}<strong parentName="p">{`Light L`}</strong>{`, `}<strong parentName="p">{`$20000`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Atlasdam`}</strong>{`. Go to `}<strong parentName="p">{`Rippletide`}</strong>{`.`}</p>
    <h3 {...{
      "id": "tressa-ch1"
    }}>{`Tressa Ch.1`}</h3>
    <h4 {...{
      "id": "mikk--makk"
    }}>{`Mikk & Makk`}</h4>
    <p>{`Light L + Light M`}</p>
    <h3 {...{
      "id": "exploration"
    }}>{`Exploration`}</h3>
    <p>{`Head to `}<strong parentName="p">{`Grandport`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Light/Ice S + Ice M kills Salamander groups in Ch2 area.`}</p>
    </blockquote>
    <p><strong parentName="p">{`North Cobbleston Pass`}</strong>{`: Optionally pick Light S, `}<strong parentName="p">{`$1200`}</strong>{`.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`North Stonegard Pass`}</strong>{`: Get `}<strong parentName="p">{`Warrior Shrine`}</strong>{`.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Moonstruck Coast`}</strong>{`: S&Q, get `}<strong parentName="p">{`Merchant Shrine`}</strong>{`.`}</p>
    <p>{`Tag `}<strong parentName="p">{`Goldshore`}</strong>{`.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`West Goldshore Coast`}</strong>{`: Scrutinize `}<strong parentName="p">{`A Safe Route`}</strong>{`.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`Grandport Coast`}</strong>{`: Pick `}<strong parentName="p">{`$20000`}</strong>{`, S&Q. Pick `}<strong parentName="p">{`Thunder L`}</strong>{`, tag `}<strong parentName="p">{`Grandport`}</strong>{`.`}</p>
    <p>{`Go to `}<strong parentName="p">{`Loch of the Lost King`}</strong>{`. Pick `}<strong parentName="p">{`Wind L`}</strong>{` and `}<strong parentName="p">{`$30000`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Rippletide`}</strong>{`.`}</p>
    <p>{`Run to `}<strong parentName="p">{`Saintsbridge`}</strong>{`, start Chapter 2.`}</p>
    <h3 {...{
      "id": "chapter-2-start"
    }}>{`Chapter 2 Start`}</h3>
    <blockquote>
      <p parentName="blockquote">{`You can afford 1 Restore Reputation with backup Chapter 3 strat.`}</p>
    </blockquote>
    <p>{`Scrutinize `}<strong parentName="p">{`Guide with Ease (50%)`}</strong>{` (Left Cleric in church).`}<br parentName="p"></br>{`
`}{`Purchase `}<strong parentName="p">{`Shadow M & L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Scrutinize `}<strong parentName="p">{`More Items in Shop (30%)`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Purchase `}<strong parentName="p">{`Wind M & Wind L`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Can skip the M Stone purchases. Need 2Ms for Cultists, rest are bonus/safety.`}<br parentName="p"></br>{`
`}{`If you skip the M Stone purchases, you can skip the 3k Scrut. Or buy Unerring Bracelet, and remove Quartz Rods during Bracelet menu and sell them in Whispermill to make up the money.`}</p>
    </blockquote>
    <p>{`Pick `}<strong parentName="p">{`Heavy Coin Pouch`}</strong>{`, Guide Daniel.`}</p>
    <p>{`S&Q outside Murkwood, kill if you got the encounter before with 2Ms or Light S + Light M.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$3500`}</strong>{`.`}</p>
    <p>{`In Murkwood kill encounter with L Stone`}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`Cyrus will usually have <160 JP`}<br parentName="p"></br>{`
`}{`If he has < 160, do Ch4 menu after drakes. If >= 160, do Job menu before Drakes.`}</p>
      </blockquote>
      <h5 {...{
        "id": "jobs"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: Donate BP + Hired Help`}</li>
        <li parentName="ul">{`Cyrus: (If >= 160JP, Donate BP + Hired Help), `}<strong parentName="li">{`Warrior`}</strong>{`, Spearhead (If < 160JP, Thousand Spears)`}</li>
        <li parentName="ul">{`Ophilia: `}<strong parentName="li">{`Merchant`}</strong>{`, Donate BP + Hired Help`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-1"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: Cover or Endless Items`}</li>
        <li parentName="ul">{`Ophilia & Tressa: Endless Items`}</li>
      </ul>
    </Menu>
    <h4 {...{
      "id": "hrodvitnir-34969hp-sword-spear-ice-lightning-light"
    }}>{`Hrodvitnir 34969HP (Sword, Spear, Ice, Lightning, Light)`}</h4>
    <h5 {...{
      "id": "turn-1-1"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Spear / Holy Light`}</li>
      <li parentName="ul">{`Cyrus: Defend / Spearhead`}</li>
      <li parentName="ul">{`Tressa: Attack / HHM`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-1"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: (Sword / Spear) x3 or Thousand Spears`}</li>
      <li parentName="ul">{`Ophilia: L Stone`}</li>
      <li parentName="ul">{`Tressa: L Stone`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-1"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Merchant 1: Collect x4`}</li>
      <li parentName="ul">{`Merchant 2: HHV x4`}</li>
      <li parentName="ul">{`Cyrus: L Stone`}</li>
    </ul>
    <h3 {...{
      "id": "chapter-3"
    }}>{`Chapter 3`}</h3>
    <p>{`Scrutinize `}<strong parentName="p">{`Copper Filled Pouch`}</strong>{` (Old Lady before entrance to second screen). This is skippable if you skipped M Stones in Ch.2.`}<br parentName="p"></br>{`
`}{`Complete `}<strong parentName="p">{`A Safe Route`}</strong>{`. Pick `}<strong parentName="p">{`$4500`}</strong>{`. Scrutinize `}<strong parentName="p">{`Wind L`}</strong>{`, pick `}<strong parentName="p">{`Pom M`}</strong>{`. Pick `}<strong parentName="p">{`Wind L`}</strong>{`.`}</p>
    <p>{`After Guide & Cutscenes `}<strong parentName="p">{`TP Grandport`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Grandport TP can be done whenever, I'm putting it late so you can buy extra Poms if you have extra money.`}</p>
    </blockquote>
    <p>{`Purchase `}<strong parentName="p">{`Healing Grape Bunch & Pom L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Silver-filled Pouch`}</strong>{`. Pick `}<strong parentName="p">{`$25000`}</strong>{`, `}<strong parentName="p">{`Dazzling Artwork`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Saintsbridge`}</strong>{`, head to `}<strong parentName="p">{`Worrywart`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "shop"
      }}>{`Shop`}</h5>
      <ul>
        <li parentName="ul">{`Buy 6 Empowering Bracelet`}</li>
        <li parentName="ul">{`Buy 1 Charm Robe, attach to Cyrus`}</li>
      </ul>
      <h5 {...{
        "id": "equipment"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Equip Bracelets to all.`}</li>
      </ul>
      <h5 {...{
        "id": "healing"
      }}>{`Healing`}</h5>
      <p>{`Heal to full.`}</p>
    </Menu>
    <p>{`Guide `}<strong parentName="p">{`Worrywart`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Goldshore`}</strong>{`.`}</p>
    <p>{`Scrutinize & Pick `}<strong parentName="p">{`Thunder L`}</strong>{`. Pick `}<strong parentName="p">{`Thunder M`}</strong>{`.`}</p>
    <h3 {...{
      "id": "path-to-the-seaside-grotto"
    }}>{`Path to the Seaside Grotto`}</h3>
    <ul>
      <li parentName="ul">{`Azure Urchin: (1) 5611HP `}{`[Spear, Thunder, Light]`}</li>
      <li parentName="ul">{`Dark Curator: (3) 4790HP `}{`[Spear, Bow, Staff, Light]`}</li>
      <li parentName="ul">{`Flame Curator: (2) 4557HP `}{`[Spear, Bow, Staff, Ice]`}</li>
      <li parentName="ul">{`Scythe Crab: (3) 2484HP `}{`[Dagger, Axe, Wind]`}</li>
      <li parentName="ul">{`Mossy Tortoise: (4) 3808HP `}{`[Sword, Wind]`}</li>
    </ul>
    <h4 {...{
      "id": "battles"
    }}>{`Battles`}</h4>
    <ul>
      <li parentName="ul">{`1 Dark Curator 2 Flame Curator: Blizzard, Ophi can Holy Light, break with Spear + Bow.`}</li>
      <li parentName="ul">{`2 Dark Curator 1 Flame Curator: Blizzard or Thousand Spears, or YOLO Flee.`}</li>
      <li parentName="ul">{`1 Azure Urchin 3 Scythe Crab: HHB x3 breaks crabs, Holy Light the Urchin. `}</li>
      <li parentName="ul">{`1 Azure Urchin 1 Mossy Tortoise: HH150, Holy Light the Urchin`}</li>
      <li parentName="ul">{`1 Azure Urchin 1 Flame Curator 1 Scythe Crab: `}<ul parentName="li">
          <li parentName="ul">{`Ophilia Holy Light Azure Urchin, Cyrus Blizzard, Tressa Defend + HHB x3`}</li>
        </ul></li>
    </ul>
    <p>{`S&Q inside Seaside Grotto.`}</p>
    <h4 {...{
      "id": "mystery-man--shady-figure-2817232197hp"
    }}>{`Mystery Man & Shady Figure (28172/32197HP)`}</h4>
    <p>{`You need an Inhibit by T3 or you lose.`}<br parentName="p"></br>{`
`}{`There are backups, will describe below.`}</p>
    <h5 {...{
      "id": "turn-1-2"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Summon`}</li>
      <li parentName="ul">{`Cyrus: Spearhead MM`}</li>
      <li parentName="ul">{`Tressa: HHB x2 / HHB`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-2"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Cyrus: Spear x3 MM`}</li>
      <li parentName="ul">{`Ophilia: Defend`}</li>
      <li parentName="ul">{`Tressa: Pom M Self / Nothing / L Stone for safety strat.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-2"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: HHDx4 / HHMx4 if you needed to restore reputation`}</li>
      <li parentName="ul">{`Cyrus: L Stone`}</li>
      <li parentName="ul">{`Tressa: HHV x4`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4-if-you-needed-to-restore-reputation"
    }}>{`Turn 4 (If you needed to restore reputation)`}</h5>
    <ul>
      <li parentName="ul">{`Merchant 1: Collect`}</li>
      <li parentName="ul">{`Other: M Stone (After Collect)`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`If you have extra resources, you can skip the boost / Pom M with Tressa and throw an L Stone T2.`}<br parentName="p"></br>{`
`}{`Then T3 use Dancers instead of Mercs, and T4 throw an L and an M. This wins without Inhibit.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`Jankier backup is to play as normal, with Dancers T3. From what I've seen, MM should do Arcane Blade T4 killing someone. You then finish with 2 L Stones and leave 1 person dead. That person probably won't survive Consuming Darkness and maybe even Black Gale anymore.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`There's also a no Inhibit strat with 3Ls but it requires Cyrus not missing, which is unreliable unless you buy Unerring Bracelet.`}</p>
    </blockquote>
    <p>{`At this point you need to have 1L 1M Stones minimum. You can get backups in Rippletide.`}</p>
    <p>{`TP `}<strong parentName="p">{`Noblecourt`}</strong>{`, head to `}<strong parentName="p">{`Whispermill`}</strong>{`.`}</p>
    <p>{`Break Plains Drake battle with Thousand Spears and Merchant Spear Attacks. Then Flee.`}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`Do this menu before Drakes if Cyrus doesn't have Thousand Spears, after if he does.`}</p>
      </blockquote>
      <h5 {...{
        "id": "jobs-1"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Cyrus: Warrior Skill if only 1 learned, `}<strong parentName="li">{`Merchant`}</strong>{`, Donate BP + Hired Help`}</li>
        <li parentName="ul">{`Ophilia: Reflective Veil, `}<strong parentName="li">{`Warrior`}</strong>{`, First 2 Skills or anything + Thousand Spears if before Drakes.`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-2"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: Cover`}</li>
        <li parentName="ul">{`Cyrus: Cover, Endless Items`}</li>
      </ul>
    </Menu>
    <p>{`Pick `}<strong parentName="p">{`Cat's Eye`}</strong>{`.`}</p>
    <h3 {...{
      "id": "chapter-4"
    }}>{`Chapter 4`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Thunder M`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-1"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`1 Grape M`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`You want to have at least 1 Grape M, 2 Grape Bunches. Extras are nice though.`}</p>
      </blockquote>
      <h5 {...{
        "id": "sell"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Everything till $88500`}</li>
      </ul>
    </Menu>
    <p>{`S&Q in second screen. Pick `}<strong parentName="p">{`$30000`}</strong>{`.`}</p>
    <h4 {...{
      "id": "cultists"
    }}>{`Cultists`}</h4>
    <p>{`Break with HHM x4, kill with 1 L Stone + 2 M Stone`}</p>
    <h4 {...{
      "id": "mattias-97686hp"
    }}>{`Mattias 97686HP`}</h4>
    <blockquote>
      <p parentName="blockquote">{`Typically you need 3 Max Vets with Inhibit, 1 3x Vets with Inhibit, and 1 Reflective Veil. Can make do with less if you have Stones. Typically, 1L 1M Stone makes up the damage from 1 HHVx4 without Inhibit.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`YOU WILL ALMOST ALWAYS NEED 2 Inhibits for this fight. Good fights are 5/6T, can extend to 9. After 9 he summons adds and you can't win.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`Figuring out variations are an exercise left to the reader. I'm just going to put a standard fight up to T5.`}<br parentName="p"></br>{`
`}{`There are bonus strats available if you have someone before Mattias T2. Typically you heal someone with Grape M T1. Then Ophilia can afford to Defend T2 instead of Reflective, which gives you a chance to get Inhibit at the start of T3. > Start of T3 Inhibit is the most optimal Inhibit, can do fight with only 1 Inhibit.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-1-3"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Summon`}</li>
      <li parentName="ul">{`Cyrus: Blizzard`}</li>
      <li parentName="ul">{`Tressa: Defend`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-3"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Tressa: HHM x2`}</li>
      <li parentName="ul">{`Cyrus: Pom L Tressa`}</li>
      <li parentName="ul">{`Ophilia: Reflective Veil character that got hit (If you had a free turn and were able to Grape M with Tressa instead of Defend, can Defend here)`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-3"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Reflective Veil other character that got hit (Inhibit hits)`}</li>
      <li parentName="ul">{`Cyrus: HHV x4`}</li>
      <li parentName="ul">{`Tressa: HHV x4`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Assuming 2 Inhibit, or T3 Inhibit`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-4"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Defend`}</li>
      <li parentName="ul">{`Cyrus: Blizzard`}</li>
      <li parentName="ul">{`Tressa: Donate BP / Pom Cyrus`}</li>
    </ul>
    <h5 {...{
      "id": "turn-5"
    }}>{`Turn 5`}</h5>
    <ul>
      <li parentName="ul">{`Ophilia: Sword x4`}</li>
      <li parentName="ul">{`Cyrus: HHV x3`}</li>
      <li parentName="ul">{`Tressa: HHV x4`}</li>
    </ul>
    <p>{`If you don't have Inhibit, replace Vets with Healing Grape Bunches. Break T7, and repeat hopefully with Inhibit. If you don't have extra Stones, you can't win if you don't get a set of Vets of with Inhibit by the end of T6.`}</p>
    <p>{`The tricky part of the fight is handling Worrywart leaving around T3-T4. Once again, will be left exercise for the runner.`}</p>
    <p>{`2 Cutscene then GG!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      